module.exports = __webpack_public_path__ + "img/home-slide.53dfcb52.png";